export default function DemoCheckCircle() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4319_6716)">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path
          d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 10.4241 23.6896 8.8637 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40041 18.0481 1.5165 16.5922 0.913445C15.1363 0.310389 13.5759 0 12 0ZM18.8112 9.8844L11.6112 16.4844C11.3832 16.6934 11.0834 16.8064 10.7742 16.7997C10.465 16.7929 10.1703 16.6671 9.9516 16.4484L6.3516 12.8484C6.23699 12.7377 6.14557 12.6053 6.08268 12.4589C6.01979 12.3125 5.98669 12.155 5.9853 11.9957C5.98392 11.8363 6.01428 11.6783 6.07462 11.5309C6.13495 11.3834 6.22406 11.2494 6.33673 11.1367C6.4494 11.0241 6.58338 10.9349 6.73086 10.8746C6.87833 10.8143 7.03635 10.7839 7.19569 10.7853C7.35502 10.7867 7.51248 10.8198 7.65889 10.8827C7.80529 10.9456 7.93771 11.037 8.0484 11.1516L10.836 13.9392L17.1888 8.1156C17.4234 7.90045 17.7338 7.7873 18.0518 7.80103C18.3697 7.81476 18.6693 7.95424 18.8844 8.1888C19.0995 8.42336 19.2127 8.73377 19.199 9.05176C19.1852 9.36974 19.0458 9.66925 18.8112 9.8844Z"
          fill="#17B26A"
        />
      </g>
      <defs>
        <clipPath id="clip0_4319_6716">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
